// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-page {
  padding: 16px;
}

.map-container-wrapper {
  height: 600px;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.dark-theme .map-container-wrapper {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
}

.map-card {
  border-radius: 8px;
}

.map-container {
  width: 100%;
  height: 100%;
}

/* Segment styling */
.segment {
  width: 24px;
  height: 24px;
  text-align: center;
  color: #fff;
  line-height: 24px;
  border-radius: 50%;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}

.segment-1 { background: #ff0200; }  /* E segment */
.segment-2 { background: #ff5600; }  /* D segment */
.segment-3 { background: #ecd300; }  /* C segment */
.segment-4 { background: #b5dc0a; }  /* B segment */
.segment-5 { background: #69d406; }  /* A segment */
.segment-6 { background: #27d60d; }  /* A+ segment */
.segment-0 { background: #d4d4d4; }  /* Unknown segment */

/* Filter panel styling */
.filter-panel {
  border-radius: 8px;
  height: 100%;
}

.filter-section {
  margin-bottom: 16px;
}

.filter-section-title {
  font-weight: 600;
  margin-bottom: 8px;
}

.metro-info-panel {
  position: absolute;
  z-index: 999;
  right: 16px;
  bottom: 16px;
  font-size: 12px;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 8px;
  border-radius: 8px;
  max-width: 300px;
}

.dark-theme .metro-info-panel {
  background-color: rgba(40, 40, 40, 0.9);
  color: #fff;
}

.metro-line {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.metro-line-badge {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  font-size: 10px;
  font-weight: bold;
}

.map-tools {
  position: absolute;
  z-index: 999;
  right: 16px;
  top: 16px;
  display: flex;
  flex-direction: column;
}

.map-tool-button {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.dark-theme .map-tool-button {
  background: #333;
  color: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
}

.map-search-box {
  position: absolute;
  z-index: 999;
  top: 16px;
  left: 16px;
  width: 300px;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .map-container-wrapper {
    height: 400px;
  }
  
  .map-search-box {
    width: calc(100% - 80px);
  }
  
  .metro-info-panel {
    max-width: 200px;
    font-size: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/harita/pages/MapPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,aAAa,mBAAmB,EAAE,GAAG,cAAc;AACnD,aAAa,mBAAmB,EAAE,GAAG,cAAc;AACnD,aAAa,mBAAmB,EAAE,GAAG,cAAc;AACnD,aAAa,mBAAmB,EAAE,GAAG,cAAc;AACnD,aAAa,mBAAmB,EAAE,GAAG,cAAc;AACnD,aAAa,mBAAmB,EAAE,GAAG,eAAe;AACpD,aAAa,mBAAmB,EAAE,GAAG,oBAAoB;;AAEzD,yBAAyB;AACzB;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":[".map-page {\n  padding: 16px;\n}\n\n.map-container-wrapper {\n  height: 600px;\n  width: 100%;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.dark-theme .map-container-wrapper {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);\n}\n\n.map-card {\n  border-radius: 8px;\n}\n\n.map-container {\n  width: 100%;\n  height: 100%;\n}\n\n/* Segment styling */\n.segment {\n  width: 24px;\n  height: 24px;\n  text-align: center;\n  color: #fff;\n  line-height: 24px;\n  border-radius: 50%;\n  font-weight: bold;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 8px;\n}\n\n.segment-1 { background: #ff0200; }  /* E segment */\n.segment-2 { background: #ff5600; }  /* D segment */\n.segment-3 { background: #ecd300; }  /* C segment */\n.segment-4 { background: #b5dc0a; }  /* B segment */\n.segment-5 { background: #69d406; }  /* A segment */\n.segment-6 { background: #27d60d; }  /* A+ segment */\n.segment-0 { background: #d4d4d4; }  /* Unknown segment */\n\n/* Filter panel styling */\n.filter-panel {\n  border-radius: 8px;\n  height: 100%;\n}\n\n.filter-section {\n  margin-bottom: 16px;\n}\n\n.filter-section-title {\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.metro-info-panel {\n  position: absolute;\n  z-index: 999;\n  right: 16px;\n  bottom: 16px;\n  font-size: 12px;\n  background-color: rgba(255, 255, 255, 0.9);\n  padding: 8px;\n  border-radius: 8px;\n  max-width: 300px;\n}\n\n.dark-theme .metro-info-panel {\n  background-color: rgba(40, 40, 40, 0.9);\n  color: #fff;\n}\n\n.metro-line {\n  display: flex;\n  align-items: center;\n  margin-bottom: 4px;\n}\n\n.metro-line-badge {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 8px;\n  font-size: 10px;\n  font-weight: bold;\n}\n\n.map-tools {\n  position: absolute;\n  z-index: 999;\n  right: 16px;\n  top: 16px;\n  display: flex;\n  flex-direction: column;\n}\n\n.map-tool-button {\n  width: 40px;\n  height: 40px;\n  border-radius: 4px;\n  background: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 8px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n}\n\n.dark-theme .map-tool-button {\n  background: #333;\n  color: #fff;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);\n}\n\n.map-search-box {\n  position: absolute;\n  z-index: 999;\n  top: 16px;\n  left: 16px;\n  width: 300px;\n}\n\n/* Mobile responsiveness */\n@media (max-width: 768px) {\n  .map-container-wrapper {\n    height: 400px;\n  }\n  \n  .map-search-box {\n    width: calc(100% - 80px);\n  }\n  \n  .metro-info-panel {\n    max-width: 200px;\n    font-size: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
